<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="sites-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-link"></i>
                        投稿サイト
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mt-3">
                        <ul class="list-group">
                            <li class="list-group-item" v-for="(u, i) in urls" :key="i">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <button type="button" class="btn btn-light btn-sm" @click="removeUrl(i)">&times;</button>
                                    </div>
                                    <input type="text" class="form-control url"
                                        v-model="u.url"
                                        @keydown.enter="addUrl()">
                                    <domain v-model="u.domain" class="input-group-append"
                                        :url="u.url"></domain>
                                </div>
                            </li>
                        </ul>
                        <div class="m-3 text-right">
                            <button type="button" class="btn btn-light btn-sm" @click="addUrl()">
                                <i class="fas fa-plus"></i>
                                追加
                            </button>
                        </div>
                    </div>
                    <div class="small m-3">
                        投稿サイトのURLを登録します。<br>
                        URLは複数追加することができます。<br>
                        投稿サイトによっては、その種類を自動判定できないものがあるので、適宜種類を選択してください。<br>
                        削除する場合は &times; ボタンで削除してから保存してください。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Domain from "components/Domain";
export default {
    components: {
        Domain
    },
    props: {
        book_id: {
            required: true
        }
    },
    data() {
        return {
            urls: [],
        }
    },
    methods: {
        load() {
            axios.get("/mypage/urls/get", {params: {book_id: this.book_id}}).then(res => {
                this.urls = res.data;
                // 新規追加用
                this.addUrl(true);
            }).catch(err => { alert.err(err.response) });
        },
        addUrl(noFocus = false) {
            if (this.urls.length > 0 &&  !this.urls[this.urls.length - 1].url) return;
            this.urls.push({
                id: null,
                url: null,
                order_number: null,
            });
            if (!noFocus) {
                setTimeout(() => { $(".url:last").focus(); });
            }
        },
        removeUrl(i) {
            this.urls.splice(i, 1);
        },
        save() {
            axios.post("/mypage/urls/save", {
                book_id: this.book_id,
                urls: this.urls
            }).then(res => {
                alert.msg(res.data);
                $("#sites-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => { alert.err(err.response) });
        }
    },
    mounted() {
        $("#sites-modal").on("show.bs.modal", (e) => {
            this.load();
            setTimeout(() => { $(".url:last").focus(); }, 500);

        });
    }
}
</script>